import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  public constructor(
    private readonly _snackBar: MatSnackBar,
    private readonly _zone: NgZone
  ) {}

  public default(message: string): void {
    this.show(message, {
      duration: 2000,
      panelClass: 'default-notification-overlay'
    });
  }

  public info(message: string): void {
    this.show(message, {
      duration: 7500,
      panelClass: 'info-notification-overlay'
    });
  }

  public success(message: string): void {
    this.show(message, {
      duration: 2000,
      panelClass: 'success-notification-overlay'
    });
  }

  public warn(message: string): void {
    this.show(message, {
      duration: 6000,
      panelClass: 'warning-notification-overlay'
    });
  }

  public error(message: string): void {
    this.show(message, {
      duration: 12500,
      panelClass: 'error-notification-overlay'
    });
  }

  private show(message: string, configuration: MatSnackBarConfig): void {
    // Need to open _snackBar from Angular _zone to prevent issues with its position per
    // https://stackoverflow.com/questions/50101912/snackbar-position-wrong-when-use-errorhandler-in-angular-5-and-material
    this._zone.run(() => this._snackBar.open(message, null, configuration));
  }
}
